<template>
    <div class="tab-button-group" role="tablist"><slot></slot></div>
</template>

<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';

    @Component
    export default class TabButtonGroup extends Vue {}
</script>

<style lang="less" scoped>
    .tab-button-group {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        padding: @spacing-4;
        background-color: @bright-color;
        border-radius: @border-radius-8;
    }
</style>
